import type { ReactNode } from "react";
import { Label } from "@/components/ui/base/label";

interface Props {
  id: string;
  label: string;
  hint?: string;
  error?: string;
  /** Renders the input; pass `describedBy` to its `aria-describedby`. */
  children: (describedBy: string | undefined) => ReactNode;
}

/** A labelled input with a hint that gives way to the validation error. */
export function Field({ id, label, hint, error, children }: Props) {
  const message = error || hint;
  const messageId = message ? `${id}-message` : undefined;
  return (
    <div className="space-y-1">
      <Label htmlFor={id} className="text-xs">
        {label}
      </Label>
      {children(messageId)}
      {message && (
        <p
          id={messageId}
          className={
            error ? "text-xs text-red-600" : "text-muted-foreground text-xs"
          }
        >
          {message}
        </p>
      )}
    </div>
  );
}
